<script lang="ts">
    import { ATTRIBUTE_TYPE } from "@apps/reviews/constants";
    import { AttributeAnswersEntity } from "@apps/reviews/entities/ReviewEntity";

    import DateAnswer from "./answers/DateAnswer.svelte";
    import LocationAnswer from "./answers/LocationAnswer.svelte";
    import MultiValueAnswer from "./answers/MultiValueAnswer.svelte";
    import RangeAnswer from "./answers/RangeAnswer.svelte";
    import TextfieldAnswer from "./answers/TextfieldAnswer.svelte";

    export let attributeAnswers: AttributeAnswersEntity;

    $: sortedAttributeAnswers = [...attributeAnswers].sort((a, b) => {
        const isRangeOrCenteredRange = (type: ATTRIBUTE_TYPE) =>
            type === ATTRIBUTE_TYPE.RANGE ||
            type === ATTRIBUTE_TYPE.CENTERED_RANGE;

        if (
            !isRangeOrCenteredRange(a.content.type) &&
            isRangeOrCenteredRange(b.content.type)
        ) {
            return -1;
        }
        if (
            isRangeOrCenteredRange(a.content.type) &&
            !isRangeOrCenteredRange(b.content.type)
        ) {
            return 1;
        }
        return 0;
    });
</script>

{#if sortedAttributeAnswers.length}
    <div class="gw-rv-attributes-answers">
        {#each sortedAttributeAnswers as attribute}
            <div class="gw-rv-attributes-answers__answer">
                <TextfieldAnswer>
                    {attribute.propertyName}
                </TextfieldAnswer>

                {#if attribute.content.type === ATTRIBUTE_TYPE.MULTI_VALUE}
                    <MultiValueAnswer
                        options={attribute.content.values || []}
                    />
                {:else if attribute.content.type === ATTRIBUTE_TYPE.TEXTFIELD || attribute.content.type === ATTRIBUTE_TYPE.SINGLE_VALUE}
                    <span class="gw-rv-attributes-answers__title">
                        {attribute.content.value}
                    </span>
                {:else if attribute.content.type === ATTRIBUTE_TYPE.RANGE}
                    <RangeAnswer
                        value={attribute.content.value}
                        minLabel={attribute.content.minLabel}
                        maxLabel={attribute.content.maxLabel}
                    />
                {:else if attribute.content.type === ATTRIBUTE_TYPE.CENTERED_RANGE}
                    <RangeAnswer
                        value={attribute.content.value}
                        minLabel={attribute.content.minLabel}
                        midLabel={attribute.content.midLabel}
                        maxLabel={attribute.content.maxLabel}
                        isCenteredRange
                    />
                {:else if attribute.content.type === ATTRIBUTE_TYPE.LOCATION}
                    <LocationAnswer
                        value={attribute.content.value}
                        label={attribute.propertyName}
                    />
                {:else if attribute.content.type === ATTRIBUTE_TYPE.DATE}
                    <DateAnswer
                        day={attribute.content.day}
                        month={attribute.content.month}
                        year={attribute.content.year}
                    />
                {/if}
            </div>
        {/each}
    </div>
{/if}

<style lang="postcss">
    .gw-rv-attributes-answers {
        line-height: normal;
        display: flex;
        flex-direction: column;
        gap: 0.75em;

        &:last-of-type {
            margin-top: 0.5em;
        }

        &__answer {
            display: flex;
            flex-direction: column;
        }

        &__title {
            font-size: 0.875em;
            font-weight: 400;
        }
    }
</style>
